import { LOGIN, PAYMENT, PIX } from "../constants/paths";
import Login from "../pages/login";
import {
  Box,
  Button,
  Collapse,
  Flex,
  Slide,
  SlideFade,
} from "@chakra-ui/react";
import axios from "axios";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "../pages/header";
import SideBar from "../pages/sidebar";
import ComponentRoutes from "./componentRoutes";
import TermosGate from "../pages/termos/termosGate";
import CardPayment from "../external-components/card_payment";
import PixPayment from "../external-components/pix_payment";
import { useState } from "react";

function RouterController() {
  axios.defaults.headers.common["Authorization"] =
    window.localStorage.getItem("token");
  const Authorized = window.localStorage.getItem("token");

  const pathname = useLocation().pathname;

  const [open, setOpen] = useState(true);

  if (
    pathname === LOGIN ||
    pathname === "/" ||
    // pathname === "/login/" ||
    pathname.includes(LOGIN) ||
    Authorized === null ||
    Authorized === undefined ||
    !Authorized
  ) {
    return (
      <Routes>
        <Route path={LOGIN} element={<Login />} />
        <Route path="/login/:hash" element={<Login />} />
        <Route exact path="/" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  } else if (pathname.includes(PAYMENT)) {
    return (
      <Routes>
        <Route path={PAYMENT} exact element={<CardPayment />} />
      </Routes>
    );
  } else if (pathname.includes(PIX)) {
    return (
      <Routes>
        <Route path={PIX} exact element={<PixPayment />} />
      </Routes>
    );
  } else {
    return (
      <Flex
        direction="row"
      // h="100vh"
      // w="100vw"
      >
        {open ? (
          <SlideFade in={open} offsetY="20px" direction={"right"}>
            <Flex maxW="300px">
              <SideBar setOpen={setOpen} />
            </Flex>
          </SlideFade>
        ) : (
          <></>
        )}
        <Flex
          w="100%"
          direction="column"
          bgColor="#F1F1F1"
          // height="100vh"
          justifyContent="space-between"
        >
          <Box
            w="100%"
            // margin="auto"
            mb="3"
            bgColor="#FFFFFF"
            // borderRadius="5"
            shadow={"md"}
            h={"8vh"}
          >
            <Header setOpen={setOpen} open={open} />
          </Box>
          <Box
            w="99%"
            margin="auto"
            bgColor="#f1f1f1"
            // mb="5"
            mt="0"
            borderRadius="6"
            h={"90vh"}
          // mx="3"
          // overflowY="scroll"
          // py={"10px"}
          >
            <ComponentRoutes />
          </Box>
          <TermosGate />
        </Flex>
      </Flex>
    );
  }
}
export default RouterController;
